// extracted by mini-css-extract-plugin
export default {"header":"Contabilidad_header__O5jNi","mes":"Contabilidad_mes__rILwr"};